import gql from "graphql-tag"

export const DELETE_SURVEY_AREA = gql`
  mutation DeleteSurveyArea($ids: [ID]!) {
    deleteSurveyArea(ids: $ids) {
      response
    }
  }
`
